/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.1
 */

/**
 * Human affected
 */
export type CreateReportDtoHumanAffected =
  (typeof CreateReportDtoHumanAffected)[keyof typeof CreateReportDtoHumanAffected];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateReportDtoHumanAffected = {
  yes: 'yes',
  no: 'no',
  dontKnow: 'dontKnow',
} as const;
